import {
  FighterFrequency,
  UserTotalPoints,
} from '../../domain/models/userSeason.model';

export interface UserSeasonStatsState {
  fighterFrequencySeasonId: string | null;
  fighterFrequency: FighterFrequency[] | null;
  usersTotalPointsSeasonId: string | null;
  usersTotalPoints: UserTotalPoints[] | null;
  isLoading: boolean;
  error: string | null;
}

export const initialUserSeasonStatsState: UserSeasonStatsState = {
  fighterFrequencySeasonId: null,
  fighterFrequency: null,
  usersTotalPointsSeasonId: null,
  usersTotalPoints: null,
  isLoading: false,
  error: null,
};
